import type { KorintModulesProductsConfig } from 'korint-sdk/react';
import { DocumentsListsPolicyModule, InvoicesScheduleModule, QuoteTierModule } from '@korint/folio';

/** Recap-only short labels for the migrated non-delegated products. The
 * dashboard premium card keeps the verbose i18n labels (Frais de courtage
 * additionnels grossiste, Supplément frais de dossier, etc.); these short
 * forms only override the funnel recap card to mirror staging Style B. */
export const TUTASSUR_RECAP_SHORT_LABELS = {
  WHOLESALE_ADDITIONAL_COMMISSION: 'Additionnels grossiste',
  RETAIL_COMMISSION: 'Distributeur',
  KORINT_MANAGEMENT_FEE: 'Supplément',
  WHOLESALE_SUBSCRIPTION_FEE: 'Grossiste',
  RETAIL_SUBSCRIPTION_FEE: 'Distributeur',
  MANAGEMENT_FEE: 'Frais de dossier TTC',
};

export const driverMtaRoutes = {
  steps: [
    {
      path: 'summary',
      type: 'module',
      module: <QuoteTierModule showModifyButton={false} />,
    },
    {
      path: 'documents',
      type: 'module',
      module: (
        <DocumentsListsPolicyModule
          displayContext="policyholder"
          categories={[
            'QUOTE',
            'TERMS_AND_CONDITIONS',
            'RELATION_CONTRACT',
            'IPID_ASSISTANCE',
            'INFORMATION_REPORT',
            'INFORMATION_SHEET',
          ]}
          pollUntilAllDocumentsAreLoaded={true}
        />
      ),
    },
    {
      path: 'invoicing-schedule',
      type: 'module',
      module: <InvoicesScheduleModule />,
    },
    {
      path: 'signature',
      type: 'intermediarySignatureFunnel',
      displayContext: 'policyholder',
    },
    {
      path: 'end',
      type: 'intermediaryFunnelEnd',
    },
  ],
} as const satisfies KorintModulesProductsConfig['policyholderMtaFunnelSteps'];
